import { useMemo as u } from "react";
import { u as g } from "./tss-DN0acMKN.mjs";
function m(t) {
  return typeof t == "object" && t !== null && !Array.isArray(t);
}
function d(t, { breakpoints: i }) {
  return Object.entries(t).reduce((r, [e, n]) => (m(n) ? Object.entries(n).forEach(([s, a]) => {
    const o = i.up(s);
    r[o] = {
      ...r[o] || {},
      [e]: a
    };
  }) : r[e] = n, r), {});
}
function l(t) {
  const i = g();
  return u(() => d(t, i), [JSON.stringify(t), i]);
}
const f = [
  "gap",
  "rowGap",
  "columnGap",
  "padding",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "paddingX",
  "paddingY",
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "marginX",
  "marginY"
];
function p(t, i) {
  return Object.keys(t).reduce(
    (r, e) => {
      const n = t[e];
      return f.includes(e) && typeof n == "number" ? r[e] = i(n) : typeof n == "object" && n !== null ? r[e] = p(n, i) : r[e] = n, r;
    },
    {}
  );
}
export {
  m as i,
  p as t,
  l as u
};
//# sourceMappingURL=transformSpacingProps-m0OnDuSS.mjs.map
